import { appDataReducerPaginationAndSearch } from './reducerMetadata';

function reduceRoutingSlugsFromAllVersions(categorizedRoutingSlugs, slug, selected) {

    // Add category to the object if it doesn't exist yet
    if (typeof categorizedRoutingSlugs[slug.category] == 'undefined') {
        categorizedRoutingSlugs[slug.category] = [];
    }

    // Prevent duplicate slugs
    let isDuplicate = false;
    categorizedRoutingSlugs[slug.category].forEach((alreadySavedSlug) => {
        if (alreadySavedSlug.name === slug.slug) {
            isDuplicate = true;
        }
    });

    if (!isDuplicate) {
        categorizedRoutingSlugs[slug.category].push({
            name: slug.slug,
            description: slug.description,
            category: slug.category,
            selected: selected,
            required: null,
        });
    }
    return categorizedRoutingSlugs;
}

// Overview of all API users of an application
export function appDataReducerApiUsers(state, action) {
    // Set metadata for the overview
    const meta = appDataReducerPaginationAndSearch(action.apiUsers.message.meta);

    // Only send the permitted slugs if there is only one connected API-user
    let permittedSlugs = null;
    if (action.apiUsers.message.data.length === 1 && action.apiUsers.message.data[0].permitted_slugs !== null) {
        permittedSlugs = action.apiUsers.message.data[0].permitted_slugs.map((routingSlug) => ({
            name: routingSlug,
        }));
    }

    let ipWhitelist = null;
    if (action.apiUsers.message.data.length === 1 && action.apiUsers.message.data[0].ip_whitelist !== null) {
        ipWhitelist = action.apiUsers.message.data[0].ip_whitelist.map((ip) => ({
            name: ip,
        }));
    }

    const apiUsers = action.apiUsers.message.data.map((apiUser) => ({
        id: apiUser.id,
        applicationId: apiUser.application_id,
        name: apiUser.name,
        apiToken: apiUser.api_token,
        applicationType: apiUser.application_type,
        hostname: apiUser.hostname,
        username: apiUser.username,
        password: apiUser.password,
        permittedSlugs: permittedSlugs,
        ipWhitelist: ipWhitelist,
        usedTemplateId: apiUser.configuration_template_id,
    }));

    return {
        meta,
        items: apiUsers,
    };
}

export function appDataReducerApiUser(state, action) {
    const apiUserDetail = action.apiUser.message.data;
    let routingSlugs = apiUserDetail.permitted_slugs;

    if (routingSlugs !== null) {
        routingSlugs = apiUserDetail.permitted_slugs.map((slug) => ({
            name: slug,
        }));
    }

    let ipWhitelist = apiUserDetail.ip_whitelist;
    if (ipWhitelist !== null) {
        ipWhitelist = apiUserDetail.ip_whitelist.map((ip) => ({
            name: ip,
        }));
    }

    return {
        id: apiUserDetail.id,
        applicationId: apiUserDetail.application_id,
        name: apiUserDetail.name,
        apiToken: apiUserDetail.api_token,
        clientId: apiUserDetail.client_id,
        createdAt: apiUserDetail.created_at,
        updatedAt: apiUserDetail.updated_at,
        applicationType: apiUserDetail.application_type,
        hostname: apiUserDetail.hostname,
        username: apiUserDetail.username,
        password: apiUserDetail.password,
        permittedRoutingSlugs: routingSlugs,
        ipWhitelist: ipWhitelist,
        usedTemplateId: apiUserDetail.configuration_template_id,
    };
}

export function appDataReducerRoutingSlugs(state, action) {
    // Categorize the routing slugs
    const categorizedRoutingSlugs = {};
    console.log(action);
    action.slugs.message.data.forEach((slug) => {
        reduceRoutingSlugsFromAllVersions(categorizedRoutingSlugs, slug, false);
    });
    return categorizedRoutingSlugs;
}

export function appDataReducerApiUserWithAllRoutingSlugs(state, action) {
    const apiUserDetail = action.apiUser.message.data;
    const configuredRoutingSlugs = [];
    const categorizedRoutingSlugs = {};

    // Select ALL modules if FlexWeb HUB returns null, which equals to all modules selected
    if (apiUserDetail.permitted_slugs === null) {
        action.slugs.message.data.forEach((slug) => {
            reduceRoutingSlugsFromAllVersions(categorizedRoutingSlugs, slug, true);
        });
    } else {
        // Get all configurated routing slugs from the user
        for (const routingSlug of apiUserDetail.permitted_slugs) {
            configuredRoutingSlugs[routingSlug] = routingSlug;
        }

        action.slugs.message.data.forEach((slug) => {
            reduceRoutingSlugsFromAllVersions(categorizedRoutingSlugs, slug, typeof configuredRoutingSlugs[slug.slug] != 'undefined');
        });
    }

    const apiUser = {
        id: apiUserDetail.id,
        applicationId: apiUserDetail.application_id,
        name: apiUserDetail.name,
        apiToken: apiUserDetail.api_token,
        ipWhitelist: apiUserDetail.ip_whitelist,
        createdAt: apiUserDetail.created_at,
        updatedAt: apiUserDetail.updated_at,
        applicationType: apiUserDetail.application_type,
        hostname: apiUserDetail.hostname,
        username: apiUserDetail.username,
        password: apiUserDetail.password,
        permittedRoutingSlugs: categorizedRoutingSlugs,
        usedTemplateId: apiUserDetail.configuration_template_id,
    };

    return apiUser;
}
